import { z } from 'zod/v4';

import { normalizeMenuWidgetArgs } from './menu-widget-args.normalization';
import { partialMenuWidgetDataSchema } from './partial-menu-widget-data.schema';

/**
 * Unlike `navigation`/`logo`, `menu` can be created in any ordinary column — it is not header/footer
 * only. No placement guard on this one.
 */
const createMenuWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the menu widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: partialMenuWidgetDataSchema
        .optional()
        .describe('Menu settings. Omit entirely to create one with the default 3-entry menu.'),
});

export const createMenuWidgetArgsSchema = z.preprocess(normalizeMenuWidgetArgs, createMenuWidgetObjectSchema);
